import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import AuthOTP from './pages/AuthOTP';
import MedicalAppointmentRecord from './pages/MedicalAppointmentRecord';
import UnsubscribeUser from './pages/UnsubscribeUser';
const ConfigRouter : React.FC = ()=>{
    return (
        <Router>
            <Route path="/auth" exact component={AuthOTP} />
            <Route path="/MedicalAppointment" exact component={MedicalAppointmentRecord} />
            <Route path="/unsubscribe/:token" exact component={UnsubscribeUser} />
        </Router>
    );
}

export default ConfigRouter;
